import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppInitFacade } from '@rd/app-init/app-init.facade';
import { AuthFacade } from '@rd/core/auth/store/facades/auth.facade';
import { UnleashFacade } from '@rd/core/facades/unleash-facade/unleash-facade.ts';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { combineLatest, Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { WestpacAuthSecureRouteDialogComponent } from './components/auth-secure-route-dialog/auth-secure-route-dialog.component';

@Injectable()
export class WestpacAuthGuard implements CanActivate {
  constructor(
    private dialogService: DialogService,
    private pageTitleService: PageTitleService,
    private translateService: TranslateService,
    private authFacade: AuthFacade,
    private appInitFacade: AppInitFacade,
    private unleashFacade: UnleashFacade,
  ) {}

  canActivate(): Observable<boolean> {
    const isReady$ = combineLatest([
      this.authFacade.isLoggedIn$,
      document.getElementsByClassName('rd-dialog-container').length > 0
        ? of(true)
        : this.appInitFacade.appReady$.pipe(delay(0)),
      this.unleashFacade.isUnleashClientReady$,
    ]);
    return isReady$.pipe(
      map(([isLoggedIn]) => {
        if (isLoggedIn) {
          return true;
        } else {
          this.dialogService.open(WestpacAuthSecureRouteDialogComponent, {
            id: 'westpac-core-auth-secure-route-dialog',
            screenMode: 'fullscreen',
            ariaLabel: this.translateService.instant(
              'accessibility.core.auth_dialog_aria_label',
            ),
            keepModalOnRouteChange: true,
          });

          this.pageTitleService.setPageTitle('login-page');
          return false;
        }
      }),
    );
  }
}
